import React from "react";
import { getAsset } from "../support/asset-import";

const Loading = () => (
  <div className="flex-grow flex items-center justify-center animate-pulse">
    <img src={getAsset("BamfordLogo")} alt="logo" />
  </div>
);

export default Loading;
